import gql from 'graphql-tag';

export const createVideoMutation = gql`
  mutation createVideoMutation($width: Int!, $height: Int!) {
    createVideo(width: $width, height: $height) {
      id
    }
  }
`;
